import { Component, ChangeDetectorRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import {
  NbAuthService,
  NbRequestPasswordComponent,
  NbAuthResult,
} from '@nebular/auth';
import { FirebaseAuthStrategy } from '../firebase-auth-strategy';

@Component({
  selector: 'ngx-custom-forgot-password',
  templateUrl: './custom-forgot-password.component.html',
  styleUrls: ['./custom-forgot-password.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CustomForgotPasswordComponent
  extends NbRequestPasswordComponent
  implements OnInit, OnDestroy {

  isDark = false;
  isLoading = false;
  email = '';

  images = [
    'assets/images/1.webp',
    'assets/images/6.webp',
    'assets/images/2.webp',
    'assets/images/3.webp',
    'assets/images/4.webp',
    'assets/images/5.webp',
  ];

  activeIndex = 0;
  private slideInterval: any;

  constructor(
    protected authSer: FirebaseAuthStrategy,
    protected authService: NbAuthService,
    protected cd: ChangeDetectorRef,
    protected router: Router,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    super(authService, {}, cd, router);
  }

  ngOnInit(): void {
    this.initializeTheme();
    this.startSlideshow();

    // Nebular user object
    this.user = { email: '' };
  }

  ngOnDestroy(): void {
    clearInterval(this.slideInterval);
  }

  /* ================= Nebular Forgot Logic ================= */

  onForgotPass(): void {
    if (!this.user?.email) return;

    this.isLoading = true;
    this.submitted = true;
    this.errors = [];
    this.messages = [];
this.authSer.requestPassword(this.user.email).subscribe(
      (result: NbAuthResult) => {
        this.isLoading = false;
        if (result.isSuccess()) {
          this.messages = result.getMessages();
          this.isLoading = false;
          this.submitted = false;
        } else {
          this.errors = result.getErrors();
        }
      },
      (err) => {
        this.isLoading = false;
        this.errors = [err.message || 'An error occurred. Please try again.'];
      }
    );
  }

  /* ================= UI helpers ================= */

  onLogin(): void {
    this.router.navigate(['/auth/login']);
  }

  private initializeTheme(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const saved = localStorage.getItem('theme');
    this.isDark = saved === 'dark';
    this.applyTheme();
  }

  toggleTheme(): void {
    this.isDark = !this.isDark;
    this.applyTheme();
  }

  private applyTheme(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    document.body.classList.toggle('dark-mode', this.isDark);
    localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
  }

  private startSlideshow(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    clearInterval(this.slideInterval);
    this.slideInterval = setInterval(
      () => (this.activeIndex = (this.activeIndex + 1) % this.images.length),
      3000
    );
  }
}
